// Dependencies
import {
  Button,
  Col,
  Form,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";

// Images
import BannerLogin from "../images2/Banner_login.png";

// Styles
import "../styles/Signup.scss";
import Swal from "sweetalert2";
import { reSendEmail } from "../services/LoginService";
import useForm from "../hooks/useForm";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { FaHome } from "react-icons/fa";

export const ReSendEmailPassword = () => {
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  let dataArray;
  let initialState = {
    fullName: "",
    lastName: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    termsAccepted: false,
  };

  const validations = {
    fullName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    lastName: {
      test: (value) => /^[a-zA-Z\s]*$/.test(value),
      message: "El nombre solo puede contener letras y espacios.",
    },
    email: {
      test: (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value),
      message:
        "El correo solo puede contener letras, numeros, puntos y guiones.",
    },
    phone: {
      test: (value) => /^\d*$/.test(value),
      message: "El teléfono solo puede contener números.",
    },
  };

  const { formData, handleChange, handleSubmit } = useForm(
    initialState,
    validations
  );

  const submitForm = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      dataArray = {
        email: formData.email,
      };
      try {
        await reSendEmail(dataArray);
        Swal.fire({
          title: "Se ha enviado el correo exitosamente!",
          text: "Por favor verifique su correo, sino encuentra el email de restablecimiento, revise su carpeta de spam.",
          icon: "success",
        }).then((e) => {
          navigate("/login");
        });
      } catch (error) {
        console.error("Hubo un error al enviar el correo:", error);
        Swal.fire({
          icon: "error",
          title: "Hubo un error al enviar el correo.",
          text: "El correo ingresado no existe por favor intente con otro.",
        });
      }
    }
    setValidated(true);
  };

  return (
    <div>
      <img
        src={BannerLogin}
        alt="Banner Sign Up"
        style={{ width: "100%", height: "100vh", objectFit: "cover" }}
      />
      <Form
        className="signup-form needs-validation rounded-4 shadow"
        onSubmit={submitForm}
        // onSubmit={(e) => handleSubmit(e, submitForm)}
        noValidate
        validated={validated}
      >
        <Row className="m-0">
          <Col xs={12}>
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip>Ir al Inicio</Tooltip>}
            >
              <Button onClick={() => navigate("/")} variant="secondary">
                <FaHome />
              </Button>
            </OverlayTrigger>
          </Col>
          <Col xs={12} className="text-center">
            <img
              src={
                "https://panel.marzahtravel.com/assets/img/logoHeaderBlanco.png"
              }
              className="w-auto"
              alt=""
            />
          </Col>
          <Col lg={12} md={12} xs={12} className="mt-2 mb-4">
            <Form.Group controlId="formEmail">
              <Form.Label className="text-white">Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
                isInvalid={
                  validated &&
                  !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
                }
              />
              <Form.Control.Feedback type="invalid">
                Email inválido.
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col lg={12} md={12} sm={12} className="">
            <p className="text-white">
              Ya me acordé de mi contraseña.{" "}
              <Link className="text-white" to="/login">
                Iniciar sesión
              </Link>
            </p>
            <Form.Group controlId="formSubmit" className="text-end">
              <Form.Label></Form.Label>
              <Button className="btn-register" type="submit">
                Enviar Email de Restablecimiento
              </Button>
            </Form.Group>
          </Col>
        </Row>
      </Form>
    </div>
  );
};
